// These templates are used as the starting draft for a report -- which is handled by the frontend.
// The AI will act as a copy-writer, replacing TODOs with draft content.

// Issue: the RichTextEditor adjusts the html: removes the wrapper div, section tags, and line-breaks.
// This can cause canvas_edits to fail-to-apply
function stripDownHtml(html) {
  let html2 = html
    .replace(/<div>/g, "")
    .replace(/<\/div>/g, "")
    .replace(/<section>/g, "")
    .replace(/<\/section>/g, "");
  html2 = html2.replace(/\n/g, "");
//   console.log("stripDownHtml", html2);
  return html2;
}

export const TCFD_REPORT_TEMPLATE = stripDownHtml(`
<div>
<h1>TCFD Report Notes for {company}</h1>

<section>
<h2>1. Foreword / Executive Summary</h2>
<p>TODO: High-level message from leadership.</p>
<p>TODO: Purpose of report and alignment with TCFD recommendations.</p>
<p>TODO: Key highlights (e.g., Renewable energy investments, update climate commitments and targets, incorporating climate risk into decision-making, stakeholder engagement.</p>
</section>

<section>
<h2>2. Introduction</h2>
<p>TODO: About the organisation (business model, scope of operations).</p>
<p>TODO: Rationale for climate reporting.</p>
<p>TODO: Links to other ESG/ISSB/SASB/CSRD disclosures if relevant.</p>
</section>

<section>
<h2>3. Governance</h2>
<h3>3.1. Board Oversight</h3>
<p>TODO: How the Board oversees climate-related risks &amp; opportunities.</p>
<p>TODO: Committees with climate mandates.</p>

<h3>3.2. Management's Role</h3>
<p>TODO: Roles of executives and management committees.</p>
<p>TODO: "Three lines of defence" or equivalent responsibility model.</p>
<p>TODO: Remuneration links to climate objectives.</p>
</section>

<section>
<h2>4. Strategy</h2>
<h3>4.1. Climate-related Risks &amp; Opportunities</h3>
<p>TODO: Identified risks (transition, physical, reputational, legal/regulatory).</p>
<p>TODO: Identified opportunities (low-carbon products, client support, new markets).</p>

<h3>4.2. Impact on Business, Strategy &amp; Financial Planning</h3>
<p>TODO: Effects on products, services, supply chain, financial planning.</p>

<h3>4.3. Time Horizons</h3>
<p>TODO: Short (0-2 yrs), medium (2-5 yrs), long (5-15 yrs) for Transition Risks and Opportunities Physical climate risks time horizons – 2030, 2050 and 2100</p>

<h3>4.4. Scenario Analysis &amp; Resilience</h3>
<p>TODO: Climate scenarios considered (e.g., SSPs, NGFS or IEA).</p>
<p>TODO: Resilience testing of strategy under the scenarios considered.</p>
</section>

<section>
<h2>5. Risk Management</h2>
<h3>5.1. Identification &amp; Assessment</h3>
<p>TODO: Processes for identifying and assessing climate risks.</p>

<h3>5.2. Risk Management Process</h3>
<p>TODO: Integration of climate risks and opportunities into enterprise risk framework.</p>
<p>TODO: Tools and methodologies (stress testing, Climate VaR, physical climate risk and carbon risk quantification models).</p>

<h3>5.3. Integration into Overall Risk Management</h3>
<p>TODO: How climate risk links to broader financial and operational risk.</p>
</section>

<section>
<h2>6. Metrics &amp; Targets</h2>
<h3>6.1. Metrics</h3>
<p>TODO: GHG emissions (Scope 1, 2, and relevant Scope 3)TODO: Financed emissions if a financial institution / weighted average carbon intensity.</p>
<p>TODO: Other KPIs (green finance % of AUM, climate VaR, implied temperature rise, etc. Relevant to financial institutions).</p>

<h3>6.2. Targets</h3>
<p>TODO: Net zero Targets</p>
<p>TODO: Interim targets (e.g., 50% reduction in carbon intensity by 2030).</p>
<p>TODO: Progress against Net Zero targets.</p>
</section>

<section>
<h2>7. References / Supporting Reports</h2>
<p>TODO: Stewardship &amp; Engagement Reports.</p>
<p>TODO: Transition Plans.</p>
<p>TODO: External frameworks (ISSB S1/S2, CDP, PRI, GRI, etc.).</p>
</section>
</div>
`);
